import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './SearchRetailers.module.scss';
import useDebouncedValue from '../../../hooks/useDebouncedValue';

export default function SearchRetailers(props) {
  const { search } = props;
  const [value, setValue] = useState('');

  const first = useRef(true);
  const debouncedValue = useDebouncedValue(value, 400);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }

    search(debouncedValue);
  }, [search, debouncedValue]);

  return (
    <div className={styles.wrapper_search}>
      <div className={styles.search}>
        <input type="text" value={value} onChange={(e) => setValue(e.target.value)} placeholder="Sales Channel Name" />
        <span className={cn('ic-search', styles['ic-search'])} />
      </div>
    </div>
  );
}

SearchRetailers.propTypes = {
  search: PropTypes.func.isRequired,
};
